import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'ATTACHMENT';

i18next.addResources('es', NAMESPACE, {
  ATTACH_IMAGE: 'Agregar imagen',
  ATTACH_VIDEO: 'Agregar video',
  ATTACH_IMAGE_FILE: 'Adjuntar foto o video',
  ATTACH_FILE: 'Adjuntar archivo',
  ATTACH_GIF: 'Adjuntar gif',
  SEARCH_GIF: 'Buscar gif - Powered by GIPHY',
  GIF_NOT_FOUND: 'No se encontraron resultados para {{search}}',
  SELECT_GIF: 'Elegir un GIF',
  SEND_ATTACHMENT: 'Enviar adjunto',
  SEND_IMAGE: 'Enviar imagen',
  AUDIO_PLAYER: 'Reproductor de audio',
  AUDIO_SLIDER: 'Control de audio',
  LOADING: 'Cargando',
  PAUSE: 'Pausar',
  PLAY: 'Reproducir',
  NO_PREVIEW: 'No hay vista previa disponible',
  ELIMINATE: 'Eliminar',
  SEND: 'Enviar',
  SENDING: 'Enviando...',
  SENDING_INFO: 'Se estan enviando archivos, aguarde por favor...',
  USAGE: 'Tamaño utilizado: {{usage}}',
  UPLOAD_S3_ERROR: 'Error al subir el archivo',
  PLAYBACK_SPEED: 'Velocidad de reproducción',
  DOWNLOAD: 'Descargar',
  PICTURE_IN_PICTURE: 'Imagen en imagen',
  PDF_DESCRIPTION_one: '{{count}} página - PDF - {{usage}}',
  PDF_DESCRIPTION_other: '{{count}} páginas - PDF - {{usage}}',
  FILE_DESCRIPTION: '{{extension}} - {{usage}}',
  SEE_DOCUMENT: 'Ver documento',
});

i18next.addResources('en', NAMESPACE, {
  ATTACH_IMAGE: 'Add photo',
  ATTACH_VIDEO: 'Add video',
  ATTACH_IMAGE_FILE: 'Add photo or video',
  ATTACH_FILE: 'Add file',
  ATTACH_GIF: 'Add gif',
  SEARCH_GIF: 'Search gif - Powered by GIPHY',
  GIF_NOT_FOUND: 'No results found for {{search}}',
  SELECT_GIF: 'Pick a GIF',
  SEND_ATTACHMENT: 'Send attachment',
  SEND_IMAGE: 'Send photo',
  AUDIO_PLAYER: 'Audio player',
  AUDIO_SLIDER: 'Audio slider',
  LOADING: 'Loading',
  PAUSE: 'Pause',
  PLAY: 'Play',
  NO_PREVIEW: 'No preview available',
  ELIMINATE: 'Remove',
  SEND: 'Send',
  SENDING: 'Sending...',
  SENDING_INFO: 'Files are being sent, please wait...',
  USAGE: 'Used size: {{usage}}',
  UPLOAD_S3_ERROR: 'Error uploading file',
  PLAYBACK_SPEED: 'Playback speed',
  DOWNLOAD: 'Download',
  PICTURE_IN_PICTURE: 'Picture in picture',
  PDF_DESCRIPTION_one: '{{count}} page - PDF - {{usage}}',
  PDF_DESCRIPTION_other: '{{count}} pages - PDF - {{usage}}',
  FILE_DESCRIPTION: '{{extension}} - {{usage}}',
  SEE_DOCUMENT: 'View document',
});

i18next.addResources('pt', NAMESPACE, {
  ATTACH_IMAGE: 'adicionar foto',
  ATTACH_VIDEO: 'Adicionar vídeo',
  ATTACH_IMAGE_FILE: 'Adicionar foto o video',
  ATTACH_FILE: 'Adicionar arquivo',
  ATTACH_GIF: 'Adicionar gif',
  SEARCH_GIF: 'Buscar gif - Powered by GIPHY',
  GIF_NOT_FOUND: 'Nenhum resultado encontrado para {{search}}',
  SELECT_GIF: 'Selecione um GIF',
  SEND_ATTACHMENT: 'Enviar anexo',
  SEND_IMAGE: 'Enviar foto',
  AUDIO_PLAYER: 'Reprodutor de áudio',
  AUDIO_SLIDER: 'Controle de áudio',
  LOADING: 'Cargando',
  PAUSE: 'Pausar',
  PLAY: 'Reproduzir',
  NO_PREVIEW: 'Nenhuma visualização disponível',
  ELIMINATE: 'Remover',
  SEND: 'Enviar',
  SENDING: 'Enviando...',
  SENDING_INFO: 'Os arquivos estão sendo enviados, aguarde...',
  USAGE: 'Tamanho usado: {{usage}}',
  UPLOAD_S3_ERROR: 'Erro ao enviar arquivo',
  PLAYBACK_SPEED: 'Velocidade de reprodução',
  DOWNLOAD: 'Descarga',
  PICTURE_IN_PICTURE: 'Foto na foto',
  PDF_DESCRIPTION_one: '{{count}} página - PDF - {{usage}}',
  PDF_DESCRIPTION_other: '{{count}} páginas - PDF - {{usage}}',
  FILE_DESCRIPTION: '{{extension}} - {{usage}}',
  SEE_DOCUMENT: 'Ver documento',
});

export const useTranslation = () =>
  usei18nextTranslation([NAMESPACE, 'GENERAL']);
